import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../auth/AuthContext';

const API = 'https://api.kallabakari.is';

export default function ChangePassword() {
  const { token, clearMustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) return setError('Lykilorðin stemma ekki.');
    if (newPassword.length < 6) return setError('Lykilorð verður að vera a.m.k. 6 stafir.');
    setLoading(true);
    try {
      await axios.patch(
        `${API}/api/company/auth/change-password`,
        { newPassword },
        { headers: { Authorization: token } }
      );
      clearMustChangePassword();
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Eitthvað fór úrskeiðis.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 w-full max-w-sm">
        <div className="mb-8 text-center">
          <img src="/images/coverlogo4.png" alt="Kalla Bakarí" className="h-20 w-auto mx-auto mb-3" />
          <p className="text-gray-700 font-semibold">Breyta lykilorði</p>
          <p className="text-gray-400 text-sm mt-1">Þú þarft að velja nýtt lykilorð áður en þú heldur áfram.</p>
        </div>

        {error && (
          <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
              Nýtt lykilorð
            </label>
            <input
              type="password"
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-stone-300 focus:border-stone-400"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
              Staðfesta lykilorð
            </label>
            <input
              type="password"
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-stone-300 focus:border-stone-400"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-stone-500 hover:bg-stone-600 disabled:opacity-50 text-white font-semibold py-2.5 rounded-lg text-sm transition-colors"
          >
            {loading ? 'Hleð...' : 'Vista lykilorð'}
          </button>
        </form>
      </div>
    </div>
  );
}
